import { combineEpics } from 'redux-observable';
// import { List } from 'immutable';
import { Observable } from 'rxjs';
import { LOADING, SUCCESS, ERROR, INIT, APP_PROJECTIONS } from '../../utils/constants';
import { getAppImageAPI, getAppQuestionsAPI, createAppAPI, getAppsAPI, getAppAPI, updateAppAPI, deleteAppAPI, deleteApplicationAPI } from './api';

export const GET_APP_IMAGE = 'advaice/create-app/GET_APP_IMAGE';
export const GET_APP_IMAGE_SUCCESS = 'advaice/create-app/GET_APP_IMAGE_SUCCESS';
export const GET_APP_IMAGE_ERROR = 'advaice/create-app/GET_APP_IMAGE_ERROR';

export const GET_APP_QUESTIONS = 'advaice/create-app/GET_APP_QUESTIONS';
export const GET_APP_QUESTIONS_SUCCESS = 'advaice/create-app/GET_APP_QUESTIONS_SUCCESS';
export const GET_APP_QUESTIONS_ERROR = 'advaice/create-app/GET_APP_QUESTIONS_ERROR';


export const CREATE_APP = 'advaice/create-app/CREATE_APP';
export const CREATE_APP_SUCCESS = 'advaice/create-app/CREATE_APP_SUCCESS';
export const CREATE_APP_ERROR = 'advaice/create-app/CREATE_APP_ERROR';

export const DELETE_APP = 'advaice/create-app/DELETE_APP';
export const DELETE_APPLICATION = 'advaice/create-app/DELETE_APPLICATION';
export const DELETE_APP_SUCCESS = 'advaice/create-app/DELETE_APP_SUCCESS';
export const DELETE_APP_SUCCESSFULLY = 'advaice/create-app/DELETE_APP_SUCCESSFULLY';
export const DELETE_APP_ERROR = 'advaice/create-app/DELETE_APP_ERROR';

export const UPDATE_APP = 'advaice/create-app/UPDATE_APP';
export const UPDATE_APP_SUCCESS = 'advaice/create-app/UPDATE_APP_SUCCESS';
export const UPDATE_APP_ERROR = 'advaice/create-app/UPDATE_APP_ERROR';

export const GET_APPS = 'advaice/create-app/GET_APPS';
export const GET_APPS_SUCCESS = 'advaice/create-app/GET_APPS_SUCCESS';
export const GET_APPS_ERROR = 'advaice/create-app/GET_APPS_ERROR';

export const GET_APP = 'advaice/create-app/GET_APP';
export const GET_APP_SUCCESS = 'advaice/create-app/GET_APP_SUCCESS';
export const GET_APP_ERROR = 'advaice/create-app/GET_APP_ERROR';

export const GET_APP_WITH_MEDIA = 'advaice/create-app/GET_APP_WITH_MEDIA';
export const GET_APP_WITH_MEDIA_SUCCESS = 'advaice/create-app/GET_APP_WITH_MEDIA_SUCCESS';
export const GET_APP_WITH_MEDIA_ERROR = 'advaice/create-app/GET_APP_WITH_MEDIA_ERROR';

export const GET_APPS_WITH_MEDIA = 'advaice/create-app/GET_APPS_WITH_MEDIA';
export const GET_APPS_WITH_MEDIA_SUCCESS = 'advaice/create-app/GET_APPS_WITH_MEDIA_SUCCESS';
export const GET_APPS_WITH_MEDIA_ERROR = 'advaice/create-app/GET_APPS_WITH_MEDIA_ERROR';

export const RESET_APPS_WITH_MEDIA = 'advaice/app/RESET_APPS_WITH_MEDIA';

export const RESET_EDIT_APP = 'advaice/app/RESET_EDIT_APP';

export const ANNUL_ERROR = 'advaice/app/annulError';


const initialState = {
  appImageStatus: INIT,
  appImage: {
    title: '',
    img: '',
  },
  appImageError: '',
  appQuestionsStatus: INIT,
  appQuestions: {

  },
  loadMore: true,
  deleteAppSuccess: '',
  deleteAppStatus: INIT,
  deleteAppError: '',
  createAppStatus: INIT,
  createAppError: '',
  getAppsStatus: INIT,
  currentEditableApp: {},
  getAppStatus: INIT,
  getAppError: '',
  getAppMediaStatus: INIT,
  getAppMediaError: '',
  getAppsError: '',
  currentAppFull: [],
  appsFullMedias: [],
  appsFullMediasStatus: INIT,
  pageAppsFullMedias: -1,
  hasMoreAppsFullMedias: true,
  createdAppId: 0,
  apps: [],
  hasMoreApps: true,
  pageApps: 0,
};

const updateApps = (apps, newApp) => {
  const index = apps.findIndex(app => app.app.id === newApp.app.id);
  const result = apps;
  if (index > -1) {
    result[index].medias = [...newApp.medias];
  }
  // console.log(index, result[index], 'here');
  return result;
};

export const createAppStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_APP_IMAGE:
    {
      return {
        ...state,
        appImageStatus: LOADING,
      };
    }
    case GET_APP_IMAGE_SUCCESS:
    {
      return {
        ...state,
        appImageStatus: SUCCESS,
        appImage: {
          ...state.appImage,
          title: action.payload.title,
          img: action.payload.img,
        },
      };
    }
    case GET_APP_IMAGE_ERROR:
    {
      return {
        ...state,
        appImage: {
          ...state.appImage,
          title: '',
          img: '',
        },
        appImageStatus: ERROR,
        appImageError: action.payload,
      };
    }
    case GET_APP_QUESTIONS: {
      return {
        ...state,
        appQuestionsStatus: LOADING,
      };
    }
    case GET_APP_QUESTIONS_SUCCESS: {
      return {
        ...state,
        appQuestions: {
          ...state.appQuestions,
          ...action.payload.data,
        },
      };
    }
    case GET_APP_QUESTIONS_ERROR: {
      return {
        ...state,
        appQuestionStatus: ERROR,
      };
    }
    case RESET_EDIT_APP: {
      return {
        ...state,
        currentEditableApp: {},
        getAppStatus: INIT,
        deleteAppStatus: INIT,
        updateAppStatus: INIT,
        createAppStatus: INIT,
        createdAppId: 0,
        getAppError: '',
      };
    }
    case CREATE_APP: {
      return {
        ...state,
        createAppStatus: LOADING,
      };
    }
    case CREATE_APP_SUCCESS: {
      return {
        ...state,
        createAppStatus: SUCCESS,
        createdAppId: action.payload.data.id,
      };
    }
    case CREATE_APP_ERROR: {
      return {
        ...state,
        createAppStatus: ERROR,
        createAppError: action.payload,
      };
    }

    case DELETE_APP: {
      return {
        ...state,
        deleteAppStatus: LOADING,
      };
    }
    case DELETE_APPLICATION: {
      return {
        ...state,
        deleteAppStatus: LOADING,
      };
    }
    case DELETE_APP_SUCCESSFULLY: {
      return {
        ...state,
        deleteAppSuccess: SUCCESS,
      };
    }
    case DELETE_APP_SUCCESS: {
      return {
        ...state,
        deleteAppStatus: SUCCESS,
      };
    }
    case DELETE_APP_ERROR: {
      return {
        ...state,
        deleteAppStatus: ERROR,
        deleteAppError: action.payload,
      };
    }

    case UPDATE_APP: {
      return {
        ...state,
        updateAppStatus: LOADING,
      };
    }
    case UPDATE_APP_SUCCESS: {
      return {
        ...state,
        updateAppStatus: SUCCESS,
      };
    }
    case UPDATE_APP_ERROR: {
      return {
        ...state,
        updateAppStatus: ERROR,
        updateAppError: action.payload,
      };
    }
    case GET_APPS: {
      return {
        ...state,
        getAppsStatus: LOADING,
      };
    }
    case GET_APPS_SUCCESS: {
      const result = action.payload.data.first ? [] : state.apps;
      // let result = [];

      // Array.prototype.push.apply(result, action.payload.data.content);

      return {
        ...state,
        getAppsStatus: SUCCESS,
        apps: [...result, ...action.payload.data.content],
        hasMoreApps: !action.payload.data.last,
        pageApps: action.payload.data.number,

      };
    }
    case GET_APPS_ERROR: {
      return {
        ...state,
        getAppsStatus: ERROR,
        getAppsError: action.payload,
      };
    }
    case GET_APP: {
      return {
        ...state,
        getAppStatus: LOADING,
      };
    }
    case GET_APP_SUCCESS: {
      return {
        ...state,
        getAppStatus: SUCCESS,
        currentEditableApp: action.payload.data.content[0],
      };
    }
    case GET_APP_ERROR: {
      return {
        ...state,
        getAppStatus: ERROR,
        getAppError: action.payload,
      };
    }
    case GET_APP_WITH_MEDIA: {
      return {
        ...state,
        getAppMediaStatus: LOADING,
      };
    }
    case GET_APP_WITH_MEDIA_SUCCESS: {
      const result = updateApps(state.appsFullMedias, action.payload.data.content[0]);
      return {
        ...state,
        appsFullMedias: [...result],
        getAppMediaStatus: SUCCESS,
      };
    }
    case GET_APPS_WITH_MEDIA: {
      return {
        ...state,

        appsFullMediasStatus: LOADING,
      };
    }
    case GET_APPS_WITH_MEDIA_SUCCESS: {
      const result = action.payload.data.first ? [] : state.appsFullMedias;
      return {
        ...state,
        appsFullMedias: [...result, ...action.payload.data.content],
        appsFullMediasStatus: SUCCESS,
        pageAppsFullMedias: action.payload.data.number,
        hasMoreAppsFullMedias: !action.payload.data.last,
      };
    }
    case RESET_APPS_WITH_MEDIA: {
      return {
        ...state,
        appsFullMedias: [],
        appsFullMediasStatus: INIT,
        pageAppsFullMedias: -1,
        hasMoreAppsFullMedias: true,
      };
    }
    case ANNUL_ERROR: {
      return {
        ...state,
        updateAppError: '',
        updateAppStatus: INIT,
        deleteAppStatus: INIT,
        deleteAppSuccess: '',
        deleteAppError: '',
      };
    }
    default:
    {
      return state;
    }
  }
};

export const getAppImage = data => ({ type: GET_APP_IMAGE, payload: data });

export const getAppWithMedia = (data) => {
  const newData = { ...data };
  newData.projection = APP_PROJECTIONS.WITH_MEDIA;
  return ({
    type: GET_APP_WITH_MEDIA,
    payload: newData,
  });
};

export const getAppsWithMedia = (data) => {
  const newData = { ...data };
  newData.projection = APP_PROJECTIONS.WITH_MEDIA;
  return ({
    type: GET_APPS_WITH_MEDIA,
    payload: newData,
  });
};

export const resetAppsWithMedia = () => ({ type: RESET_APPS_WITH_MEDIA });

export const createApp = data => ({ type: CREATE_APP, payload: data });

export const deleteApp = data => ({ type: DELETE_APP, payload: data });

export const deleteApplication = data => ({ type: DELETE_APPLICATION, payload: data });

export const resetEditApp = () => ({ type: RESET_EDIT_APP });

export const updateApp = data => ({ type: UPDATE_APP, payload: data });

export const getAppQuestions = () => ({ type: GET_APP_QUESTIONS });

export const getApps = data => ({ type: GET_APPS, payload: data });

export const getApp = data => ({ type: GET_APP, payload: data });

export const annulError = () => ({ type: ANNUL_ERROR });

export const getAppImageObservable = (store, requestData) => Observable
  .fromPromise(getAppImageAPI(requestData))
  .map(data => ({ type: GET_APP_IMAGE_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_APP_IMAGE_ERROR, payload: err }));

export const getAppQuestionsObservable = (store, requestData) => Observable
  .fromPromise(getAppQuestionsAPI(requestData))
  .map(data => ({ type: GET_APP_QUESTIONS_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_APP_QUESTIONS_ERROR, payload: err }));

export const createAppObservable = (store, requestData) => Observable
  .fromPromise(createAppAPI(requestData))
  .map(data => ({ type: CREATE_APP_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: CREATE_APP_ERROR, payload: err }));

export const deleteAppObservable = (store, requestData) => Observable
  .fromPromise(deleteAppAPI(requestData))
  .map(() => ({ type: DELETE_APP_SUCCESS, payload: 'Application hide success' }))
  .catch(err => Observable.of({ type: DELETE_APP_ERROR, payload: err }));

export const deleteApplicationObservable = (store, requestData) => Observable
  .fromPromise(deleteApplicationAPI(requestData))
  .map(() => ({ type: DELETE_APP_SUCCESSFULLY, payload: 'Application deleted success' }))
  .catch(err => Observable.of({ type: DELETE_APP_ERROR, payload: err }));

export const updateAppObservable = (store, requestData) => Observable
  .fromPromise(updateAppAPI(requestData))
  .map(data => ({ type: UPDATE_APP_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: UPDATE_APP_ERROR, payload: err }));

export const getAppsObservable = (store, requestData) => Observable
  .fromPromise(getAppsAPI(requestData))
  .map(data => ({ type: GET_APPS_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_APPS_ERROR, payload: err }));

export const getAppObservable = (store, requestData) => Observable
  .fromPromise(getAppAPI(requestData))
  .map(data => ({ type: GET_APP_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_APP_ERROR, payload: err }));

export const getAppWithMediaObservable = (store, requestData) => Observable
  .fromPromise(getAppsAPI(requestData))
  .map(data => ({ type: GET_APP_WITH_MEDIA_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_APP_WITH_MEDIA_ERROR, payload: err }));

export const getAppsWithMediaObservable = (store, requestData) => Observable
  .fromPromise(getAppsAPI(requestData))
  .map(data => ({ type: GET_APPS_WITH_MEDIA_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_APPS_WITH_MEDIA_ERROR, payload: err }));

export const getAppImageEpic = (action$, store) => action$
  .ofType(GET_APP_IMAGE)
  .flatMap(action => getAppImageObservable(store, action.payload));

export const getAppQuestionsEpic = (action$, store) => action$
  .ofType(GET_APP_QUESTIONS)
  .flatMap(action => getAppQuestionsObservable(store, action.payload));

export const createAppEpicLocal = (action$, store) => action$
  .ofType(CREATE_APP)
  .flatMap(action => createAppObservable(store, action.payload));

export const deleteAppEpic = (action$, store) => action$
  .ofType(DELETE_APP)
  .flatMap(action => deleteAppObservable(store, action.payload));

export const deleteApplicationEpic = (action$, store) => action$
  .ofType(DELETE_APPLICATION)
  .flatMap(action => deleteApplicationObservable(store, action.payload));

export const updateAppEpic = (action$, store) => action$
  .ofType(UPDATE_APP)
  .flatMap(action => updateAppObservable(store, action.payload));

export const getAppsEpic = (action$, store) => action$
  .ofType(GET_APPS)
  .flatMap(action => getAppsObservable(store, action.payload));

export const getAppEpic = (action$, store) => action$
  .ofType(GET_APP)
  .flatMap(action => getAppObservable(store, action.payload));

export const getAppWithMediaEpic = (action$, store) => action$
  .ofType(GET_APP_WITH_MEDIA)
  .flatMap(action => getAppWithMediaObservable(store, action.payload));

export const getAppsWithMediaEpic = (action$, store) => action$
  .ofType(GET_APPS_WITH_MEDIA)
  .flatMap(action => getAppsWithMediaObservable(store, action.payload));

export const createAppEpic = combineEpics(
  getAppImageEpic,
  getAppQuestionsEpic,
  createAppEpicLocal,
  getAppsEpic,
  getAppWithMediaEpic,
  getAppsWithMediaEpic,
  getAppEpic,
  updateAppEpic,
  deleteAppEpic,
  deleteApplicationEpic,
);



// WEBPACK FOOTER //
// ./src/reducers/create-app/duck.js